/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_Tlg_ShippingInputs */

const en_mapping_system_tlg_shipping = /** @type {(inputs: Mapping_System_Tlg_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLG Shipping`)
};

/**
* | output |
* | --- |
* | "TLG Shipping" |
*
* @param {Mapping_System_Tlg_ShippingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_tlg_shipping = /** @type {((inputs?: Mapping_System_Tlg_ShippingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_Tlg_ShippingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_tlg_shipping(inputs)
});